import React, { useEffect, useState } from 'react'
import AssessmentWrapper from '../../AssessmentWrapper'
import { Modal } from "antd";
import Close from "../../../../resources/imgs/modal/close.svg";
import { FaChevronRight } from "react-icons/fa";
import Progress from "../../progress";
import HelpBtn from "../../../../resources/imgs/assessment/helpBtn.svg"
import { useRecoilValue } from 'recoil'
import { assessmentAtom } from "../../../../state/assessment";
import { addAssessment } from '../../../../services/assessment';

// Import all character images for dynamic usage
import Joey1 from "../../../../resources/imgs/assessment/characters/joey1.png"
import Karl1 from "../../../../resources/imgs/assessment/characters/karl1.png"
import Manuel1 from "../../../../resources/imgs/assessment/characters/manuel1.png"
import Pamela1 from "../../../../resources/imgs/assessment/characters/pamela1.png"
import Peter1 from "../../../../resources/imgs/assessment/characters/peter1.png"
import Reina1 from "../../../../resources/imgs/assessment/characters/reina1.png"
import Roy1 from "../../../../resources/imgs/assessment/characters/roy1.png"
import Samantha1 from "../../../../resources/imgs/assessment/characters/samantha1.png"
import Trish1 from "../../../../resources/imgs/assessment/characters/trish1.png"

var initialRes = {
  module: 4,
  moduleKey: "guest_recall",
  C_faceNameMatching: []
}

// Updated Module 4-6 with cognitive scoring (Module 4C)
function Module4_6Content({ nextPage, recordScore, cardData, handleModuleComplete }) {
  const assessment = useRecoilValue(assessmentAtom);
  
  // Map of character names to their images
  const characterImages = {
    "Manuel": Manuel1,
    "Pamela": Pamela1,
    "Trish": Trish1,
    "Karl": Karl1,
    "Joey": Joey1,
    "Reina": Reina1,
    "Peter": Peter1,
    "Roy": Roy1,
    "Samantha": Samantha1
  };
  
  // Gender-categorized names for wrong answers
  const maleNames = [
    "Michael", "David", "John", "Robert", "James", "Daniel", "William",
    "Joseph", "Thomas", "Christopher", "Anthony", "Matthew", "Mark",
    "Donald", "Steven", "Paul", "Andrew", "Kenneth", "Joshua", "Kevin",
    "Brian", "George", "Edward", "Ronald", "Timothy"
  ];
  
  const femaleNames = [
    "Jessica", "Emily", "Sarah", "Linda", "Karen", "Lisa", "Barbara",
    "Nancy", "Betty", "Margaret", "Sandra", "Ashley", "Kimberly",
    "Donna", "Carol", "Michelle", "Dorothy", "Amanda", "Melissa",
    "Deborah", "Stephanie", "Rebecca", "Laura", "Sharon", "Cynthia"
  ];
  
  const nonBinaryNames = [
    "Pat", "Jess", "Sam", "Alex", "Jordan", "Taylor", "Casey", 
    "Morgan", "Avery", "Riley", "Quinn", "Cameron", "Drew", "Blake"
  ];
  
  // Helper function to get gender of a guest - now dynamic based on all 9 characters
  const getGuestGender = (name) => {
    const maleGuests = ["Manuel", "Karl", "Peter", "Roy"];
    const femaleGuests = ["Pamela", "Trish", "Reina", "Samantha"];
    const nonBinaryGuests = ["Joey"];
    
    if (maleGuests.includes(name)) return "male";
    if (femaleGuests.includes(name)) return "female";
    if (nonBinaryGuests.includes(name)) return "nonbinary";
    return "unknown";
  };
  
  // Get appropriate wrong answer names based on gender
  const getWrongAnswerNames = (gender, count) => {
    let namePool;
    switch(gender) {
      case "male":
        namePool = maleNames;
        break;
      case "female":
        namePool = femaleNames;
        break;
      case "nonbinary":
        namePool = nonBinaryNames;
        break;
      default:
        namePool = [...maleNames, ...femaleNames];
    }
    return shuffleArray(namePool).slice(0, count);
  };
  const [selectedNames, setSelectedNames] = useState([]);
  const [index, setIndex] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [selectedProblems, setSelectedProblems] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    console.log('🔍 Module4C useEffect called with cardData:', cardData);
    
    if (!cardData || cardData.length === 0) {
      console.log('⚠️ Module4C: No cardData available yet');
      return;
    }

    let shuffledCardData = shuffleArray(cardData);
    let tempArr = [];
    for (let i = 0; i < 6; i++) {
      // Get the correct guest for this problem
      const currentGuest = shuffledCardData[i];
      const guestGender = getGuestGender(currentGuest.name);
      
      // Get 3 wrong answer names of the same gender
      const wrongAnswers = getWrongAnswerNames(guestGender, 3);
      
      // Add the correct name to the options
      const allOptions = [...wrongAnswers, currentGuest.name];
      
      // Use the image from cardData if available (otherImg), otherwise fall back to character map
      const guestImage = currentGuest.otherImg || characterImages[currentGuest.name];
      
      tempArr.push({
        img: guestImage,
        names: shuffleArray(allOptions),
        correctName: currentGuest.name
      })
    }
    console.log('🔍 Module4C: Generated problems:', tempArr);
    setSelectedProblems(tempArr);
  }, [cardData]) // Removed characterImages from dependencies - it's a static mapping

  const shuffleArray = (array) => {
    const arr = [...array];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  };

  const showModal = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const nextStep = async () => {
    const correctAnswer = selectedProblems[index].correctName;
    const userAnswer = selectedProblems[index].names[selectedIndex];
    const isCorrect = correctAnswer === userAnswer;

    // Record the score (difficulty 1 for Module 4C, 1 point per correct answer)
    if (recordScore) {
      recordScore(isCorrect, {
        moduleKey: "guest_recall",
        questionNumber: index + 1,
        totalQuestions: 6,
        userAnswer: userAnswer,
        correctAnswer: correctAnswer,
        options: selectedProblems[index].names
      });
    }

    initialRes.C_faceNameMatching.push({
      imageId: "1.jpg",
      options: [...selectedProblems[index].names],
      correctAnswer: correctAnswer,
      userAnswer: userAnswer,
      isCorrect: isCorrect,
    })

    if (index === 5) {
      // Final question - complete module
      if (handleModuleComplete) {
        const correctAnswers = initialRes.C_faceNameMatching.filter(answer => answer.isCorrect).length;
        // Delay handleModuleComplete to allow score popup to display
        setTimeout(() => {
          handleModuleComplete({
            moduleKey: "guest_recall",
            totalQuestions: 6,
            correctAnswers,
            percentageScore: (correctAnswers / 6) * 100,
            difficulty: 1
          });
        }, 2500);
      } else {
        // Original behavior for non-scoring mode
        // Module 4C completed - original mode
        console.log('Module 4C completed', initialRes);
        nextPage();
      }
    } else {
      setIndex(index + 1);
      setSelectedIndex(-1);
    }
  }

  return (
    <div className="module1-main">
      <div className="module1-wrap">
        <Progress number="04." percent={1 / 2} />
        <div className="module1-content-wrap">
          <div className="module1-logo">Module 4</div>
          <div className="module1-body">
            <div className="module1-title">
              Who is this?
            </div>
          </div>
        </div>
      </div>

      <div className="img-container">
        <img
          className="module1-content2 module1-woman-img module4c-guest-img"
          src={selectedProblems.length && selectedProblems[index].img}
        ></img>
      </div>
      <div className="module1-categories"></div>
      <div className="module1-dishes module1-dishes2 module4-dishes">
        {selectedProblems.length && selectedProblems[index].names.map((name, i) => (
          <div
            key={i}
            className="module1-dish module6-dish"
            onClick={() => setSelectedIndex(i)}
            style={{ background: selectedIndex === i ? "#F277C6" : "" }}
          >
            {name}
          </div>
        ))}
      </div>

      <div className='next-btn-group'>
        <div className='help-btn-group'>
          <div className='help-btn-effect1'></div>
          <div className='help-btn-effect2'></div>
          <img src={HelpBtn} onClick={() => showModal()} />
          <div className='help-content'>Do you need help?</div>
        </div>

        {selectedIndex !== -1 && (
          <div
            className="assessment-next-btn"
            onClick={() => { nextStep() }}
          >
            Next{" "}
            <div
              style={{
                paddingTop: "5px",
                display: "inline-block",
              }}
            >
              <FaChevronRight color="white" size={16} />
            </div>
          </div>
        )}
      </div>

      <Modal
        open={open}
        onOk={() => showModal()}
        onCancel={() => hideModal()}
        closeIcon={<img src={Close}></img>}
        footer={null}
      >
        <div className="direction-modal-container">
          <div className='direction-modal-title'>Directions</div>
          <div className='direction-modal-content'>
            Now that your ability to remember faces and names has been put to the test separately, let’s combine those exercises and see if you remember the name of each guest when presented with their image.
          </div>
        </div>
      </Modal>
    </div>
  )
}

// Scored wrapper for Module 4C
export const ScoredModule4_6 = (props) => (
  <AssessmentWrapper 
    moduleType="4C" 
    isAdaptive={false}
    onModuleComplete={props.onModuleComplete}
  >
    <Module4_6Content {...props} />
  </AssessmentWrapper>
);

export default function Index(props) {
  return <Module4_6Content {...props} />;
}
